import { Form as FinalForm, Field } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import useAdminpoly, { Form, validate } from './hooks/useAdminpoly'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Button from '../control/Button'
import ProvinceInput from '../component/input/ProvinceInput'
import DistrictInput from '../component/input/DistrictInput'
import SubdistrictInput from '../component/input/SubdistrictInput'

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(4),
    },
}))

const initialValues = {
    // provinceID: 10,
    // districtID: 2,
    // subDistrictID: 1,
}

const Adminpoly = () => {
    const { onSubmit, provinceList } = useAdminpoly()
    const { t } = useTranslation()
    const classes = useStyles()

    const validates = (values: Form) => {
        const validation = validate(values, t) || {}
        return validation
    }

    return (
        <div className={classes.root}>
            <Grid container>
                <Grid container>
                    <Typography variant="h3" gutterBottom>
                        Adminpoly's Example
                    </Typography>
                </Grid>
                <Grid container>
                    <FinalForm onSubmit={onSubmit} validate={validates} initialValues={initialValues}>
                        {({ handleSubmit, values }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Field
                                            name="provinceID"
                                            label={t('LABEL.PROVINCE')}
                                            component={ProvinceInput}
                                            options={provinceList?.map((item) => ({
                                                value: item.id,
                                                label: item.name.th,
                                            }))}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            name="districtID"
                                            label={t('LABEL.DISTRICT')}
                                            component={DistrictInput}
                                            provinceID={values.provinceID}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            name="subDistrictID"
                                            label={t('LABEL.SUB_DISTRICT')}
                                            component={SubdistrictInput}
                                            provinceID={values.provinceID}
                                            districtID={values.districtID}
                                            required
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1}>
                                    <Grid item md={12}>
                                        <Button color="primary" onClick={handleSubmit}>
                                            {t('BUTTON.SAVE')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </FinalForm>
                </Grid>
            </Grid>
        </div>
    )
}

export default Adminpoly
